import { asGroupedFieldOptionsForFilter } from 'module/helpers/filter/grouped-field-transformer';
import { useTranslate } from 'module/hooks/use-translation';
import { GroupedFilter } from 'module/types/filter-field/grouped-filter/filter';
import { FilterGroupType } from 'module/types/filter-field/grouped-filter/group';
import { CenterAlignedBox } from 'module/ui/components/atoms/layout/layout';
import { GroupedFilterDrawer } from 'module/ui/components/molecules/field-filter/drawer/grouped-filter-drawer';
import { faFilter } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useExternalTeamMemberFieldsAsFilterableField } from 'helpers/fields/external-team-members-fields/fields';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

const Title = styled(CenterAlignedBox)`
  display: flex;
  align-items: center;
  gap: var(--spacing-04);
`;

const TitleDescription = styled.div`
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-regular);
  color: var(--gray-70);
`;

interface FilterProp {
  filter: GroupedFilter;
  onDone: (filter: GroupedFilter) => void;
  closeFilterDrawer: () => void;
  isFilterDrawerVisible: boolean;
}

export const ParticipantFilterDrawer = ({
  filter,
  onDone,
  isFilterDrawerVisible,
  closeFilterDrawer,
}: FilterProp) => {
  const { fields: PeopleFields } =
    useExternalTeamMemberFieldsAsFilterableField();

  const groupedFields = asGroupedFieldOptionsForFilter(
    {
      [FilterGroupType.User]: {
        fields: PeopleFields,
      },
    },
    useTranslate(),
  );

  return (
    <>
      <GroupedFilterDrawer
        title={
          <div>
            <Title>
              <FontAwesomeIcon icon={faFilter} />
              <FormattedMessage id="participants_filter" />
            </Title>
            <TitleDescription>
              <FormattedMessage id="pages.filter_description" />
            </TitleDescription>
          </div>
        }
        hideRemoveButton={true}
        fields={groupedFields}
        filter={filter}
        onChange={onDone}
        visible={isFilterDrawerVisible}
        onClose={closeFilterDrawer}
      />
    </>
  );
};
